import { Breadcrumbs, Link, Typography } from "@mui/material";
import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import StatCard from "../../../../../common/components/statCard";
import { usePrincipalGestaoEPIViewModel } from "../../viewModels/gestao_epi_principal_view_model";

import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";


export const PrincipalGestaoEPI = () => {
  const viewModel = usePrincipalGestaoEPIViewModel();

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <></>
                        // <div className="flex flex-row gap-2">
                        //     <div className="w-[10rem]">
                        //         <PrimaryButton
                        //             buttonColor="yellow"
                        //             onClick={viewModel.handleRelatorio}>
                        //             Gerar relatório
                        //         </PrimaryButton>
                        //     </div>
                        // </div>
                    }
                />
            </PageTopBar>

            {/**
        * Page
        */}

            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Gestão de EPI
                    </Link>
                    <Typography className="text-primary-green">
                        Principal Gestão de EPI
                    </Typography>
                </Breadcrumbs>

                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Principal Gestão de EPI </h1>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>

                    <div className="w-full justify-end flex gap-2"></div>
                </div>
                {
                    viewModel.errorMessage !== undefined
                        ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={viewModel.errorMessage}
                                    onTryAgain={viewModel.handleReload} />
                            </div>
                        ) : (
                            <>
                                {
                                    viewModel.dashboardEPIInformation !== null && (
                                        <div className="w-full flex flex-col gap-4 mb-8">

                                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                                                <StatCard
                                                    title='Nº de EPI entregues '
                                                    value={viewModel.dashboardEPIInformation.nEPIEntregues}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-red-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-red-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.nEPIEntregues)}
                                                />

                                                <StatCard
                                                    title='Assinaturas pendentes'
                                                    value={viewModel.dashboardEPIInformation.assinaturasPendentes}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-yellow-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-yellow-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.assinaturasPendentes)}
                                                />

                                              
                                            </div>
                                           
                                        </div>
                                    )
                                }
                            </>
                        )
                }
            </div>

        </>
    );
}